import { useQuery } from '@tanstack/react-query'
import { getMediaPicture } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useUniversePic(ids: number[]) {
  return useQuery({
    enabled: !!ids.length,
    queryKey: queryKeys.universePic(ids),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted)
        return getMediaPicture('universe', ids)
    },
    retry: false,
    staleTime: 1000 * 60 * 15,
  })
}
